import api from './api';

export interface Bank {
  id: number;
  name: string;
  account_number: string;
  ifsc_code: string;
  branch: string;
  address: string;
  created_at: string;
  updated_at: string;
}

export interface CreateBankRequest {
  name: string;
  accountNumber: string;
  ifscCode: string;
  branch: string;
  address: string;
}

export interface UpdateBankRequest extends CreateBankRequest {
  id: number;
}

class BankService {
  async getBanks(): Promise<Bank[]> {
    try {
      const response = await api.get<{status: boolean, data: Bank[]}>('/banks');
      // Ensure we return an array even if the response is malformed
      console.log("responseBank::::::::", response)
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching banks:', error);
      throw error;
    }
  }

  async createBank(bankData: CreateBankRequest): Promise<Bank> {
    try {
      const response = await api.post<{status: boolean, data: Bank}>('/banks', bankData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating bank:', error);
      throw error;
    }
  }

  async updateBank(bankData: UpdateBankRequest): Promise<Bank> {
    try {
      const response = await api.put<{status: boolean, data: Bank}>(`/banks/${bankData.id}`, bankData);
      return response.data.data;
    } catch (error) {
      console.error('Error updating bank:', error);
      throw error;
    }
  }

  async deleteBank(id: number): Promise<void> {
    try {
      await api.delete(`/banks/${id}`);
    } catch (error) {
      console.error('Error deleting bank:', error);
      throw error;
    }
  }
}

const bankService = new BankService();
export default bankService; 